import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import PmorderDashboard from '../PmorderDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import PmorderPageImpl from './PmorderPageImpl';

export default function PmorderPage() {
    const {MobileView} = useSelector((state) => state.menu);
    const dispatch = useDispatch();
    const { pmorderList} = useSelector((state)=>state.pharmaslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!MobileView}));
    },[]);

    return (
        < PmorderPageImpl />
    )

}